import initWidgets from "@Widgets/config/init";
import initApp from "@App/config/init";

export default async function init() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((window as any).reactLoaded) return;

  await initApp();
  await initWidgets();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).reactLoaded = true;
}
